var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"download"},[_c('banner',{attrs:{"img":"../assets/img/appDown.jpg","title":"下载APP"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }